import { MAX_CELLS_PER_ROW, ROW_COL_SPAN } from '@modules/dashboard/constants';
import { DashboardCell } from 'generated/graphql';

export function addNewCellToRow(
  rowCellItems: DashboardCell[],
  newCell: DashboardCell,
  newCellIdx: number,
) {
  const numTotalCells = rowCellItems.length + 1;

  const equalSizeCellColSpan = ROW_COL_SPAN / numTotalCells;

  if (numTotalCells <= MAX_CELLS_PER_ROW) {
    rowCellItems.splice(newCellIdx, 0, newCell);
  }
  rowCellItems.forEach((item) => {
    item.columnSpan = equalSizeCellColSpan;
  });
}
